import React, { Component , useState } from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import Immutable from 'seamless-immutable';
import classnames from 'classnames';
import { withRouter, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertFromHTML, convertToHTML } from 'draft-convert';
import Loader from '../../components/Loader';
import axios from 'axios';
import reducer from './reducer';
import * as actions from './actions';
import SelectSearch from 'react-select-search';
import { videoToString } from '../../utils/helpers';
import RUG, { DropArea, DragArea } from 'react-upload-gallery'
import 'react-upload-gallery/dist/style.css' // or scss
import FormRepeater from '../Forms/FormRepeater';
import slugify from 'slugify';
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";
import countries from '../ProductAdmin/data/countries';
import PremiumFeature from '../../components/PremiumFeature'
import { withTracking } from 'react-tracking';
import { brandRequest } from '../BrandAdmin/saga';
import { toast } from "react-toastify";
import { Alert } from '@mui/material';

const wysiwygFields = ['supportDetails', 'availableToParentsDetails', 'story', 'usage', 'training', 'trialSetUp', 'techRequirements', 'additionalPricingInformation'];
const initialState = {
  specifications: [],
  betterLearningFeatures: [],
  activeTab: '1',
  demoLink: '',
  story: '',
  shortDescription: '',
  website: '',
  dataPrivacy: '',
  specialOffer: '',
  techRequirements: '',
  requirements: [
    { title: 'Available Offline', selected: false },
    { title: 'Internet - Low Bandwidth', selected: false },
    { title: 'Internet - High Bandwidth', selected: false },
    { title: 'Desktop - Mac', selected: false },
    { title: 'Desktop - Windows', selected: false },
    { title: 'Desktop - Chromebook', selected: false },
    { title: 'Desktop - Linux', selected: false },
    { title: 'Mobile - iPhone', selected: false },
    { title: 'Mobile - iPad', selected: false },
    { title: 'Mobile - Windows', selected: false },
    { title: 'Mobile - Android', selected: false },
    { title: 'Radio', selected: false },
    { title: 'Television', selected: false },
  ],
  localisations: [
    { title: 'United Kingdom', selected: false },
  ],
  techSupport: [
    {
      title: 'Email/Help Desk',
      selected: false,
    },
    {
      title: 'FAQs/Forum',
      selected: false,
    },
    {
      title: 'Knowledge Base',
      selected: false,
    },
    {
      title: 'Phone Support',
      selected: false,
    },
    {
      title: '24/7 Live Rep',
      selected: false,
    },
  ],
  terms: '',
  training: '',
  trainingSelection: [
    { title: 'In Person', selected: false },
    { title: 'Live Online', selected: false },
    { title: 'Webinars', selected: false },
    { title: 'Documentation', selected: false },
    { title: 'Videos', selected: false },
  ],
  trialSetUp: '',
  usage: '',
  logo: null,
  images: null,
  purchaseModels: [
    {
      key: 'Outright Purchase',
      title: 'Outright Purchase',
      selected: false,
    },
    {
      key: 'Operating Lease',
      title: 'Operating Lease',
      selected: false,
    },
    {
      key: 'Parental Contributions',
      title: 'Parental Contributions',
      selected: false,
    },
    {
      key: 'GiftAid',
      title: 'GiftAid',
      selected: false,
    },
  ],
  ageRange: [
    {
      key: '0-4',
      title: '0-4 years old',
      selected: false,
    },
    {
      key: '5-7',
      title: '5-7 years old',
      selected: false,
    },
    {
      key: '8-10',
      title: '8-10 years old',
      selected: false,
    },
    {
      key: '11-13',
      title: '11-13 years old',
      selected: false,
    },
    {
      key: '14-16',
      title: '14-16 years old',
      selected: false,
    },
    {
      key: '17-18',
      title: '17-18 years old',
      selected: false,
    },
    {
      key: '19+',
      title: '19 and older',
      selected: false,
    },
  ],
  // supervision: false,
  additionalPricingInformation: '',
  video: '',
  name: '',
  priceStartingFrom: {},
  pricingPage: '',
  battery: '', 
  camera: '',
  display: '',
  memory: '',
  os: '',
  processor: '',
  storage: '',
  warranty: '',
  weight: '',
};

const currentYear = (new Date()).getFullYear();
const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));

export class DeviceAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentDidMount = () => {
    const { device, brands } = this.props;

    if (device && brands) {
      this.setStateFromProps(device, brands);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { device, brands } = nextProps;

    if ((!this.props.device && device && brands) || (device && brands && device.slug !== this.props.device.slug)) {
      // this.props.dispatchResetState();
      this.setState(initialState, this.setStateFromProps(device, brands));
    }
  }

  setStateFromProps = (device, brands) => {
    this.setState({
      ...initialState,
      brand: brands.filter(b => b.slug !== 'add-listing').map(item => ({
        ...item,
        selected: false,
      })),
    }, () => {
      
      Object.keys(device).forEach(property => {

        if (['purchaseModels'].includes(property)) {
          const purchaseModels = device.purchaseModels.map(model => {
            if (['Monthly Subscription', 'Annual Subscription'].includes(model)) return 'Paid Subscription';
            return model;
          })

          const newProperty = this.state[property].map(x => {
            if (purchaseModels && purchaseModels.includes(x.key)) return {...x, selected: true};
            return {...x, selected: false};
          });
          this.setState({[property]: newProperty});

        } else if (['brand'].includes(property)) {
          const newProperty = this.state[property].map(x => {
            if (device[property] && device[property] === x.slug) return {...x, selected: true};
            return {...x, selected: false};
          });
          this.setState({[property]: newProperty});

        } else if (['requirements', 'localisations', 'trainingSelection'].includes(property)) {
          const newProperty = this.state[property].map(x => {
            if (device[property] && device[property].includes(x.title)) return {...x, selected: true};
            return {...x, selected: false};
          });
          this.setState({[property]: newProperty});
    
        } else if (['ageRange'].includes(property)) {

          const newProperty = this.state[property].map(x => {
            if (device[property] && device[property].includes(x.key)) return {...x, selected: true};
            return {...x, selected: false};
          });
          this.setState({[property]: newProperty});

        } else if (wysiwygFields.includes(property)) {
          this.setState({[property]: EditorState.createWithContent(convertFromHTML(device[property]))});

        } else if (property === 'techSupport') {
          const techSupport = this.state.techSupport.map(item => {
            const support = Array.isArray(device[property]) ? device[property] : device[property].split(',');
            if (support.map(item => item.trim()).includes(item.title)) return {...item, selected: true};
            return {...item, selected: false};
          });
          this.setState({techSupport});

        } else if (['true', 'false', true, false].includes(device[property])) {
          this.setState({[property]: ['true', true].includes(device[property]) ? 'Yes' : 'No'});

        } else if (property === 'CTAButtonText') {
            this.setState({[property]: device[property].toLowerCase()});

        } else if (property === 'video') {
          this.setState({video: videoToString(device.video)});

        } else if (['logo'].includes(property)) {
          this.setState({[property]: [device[property].url_126]});

        } else if (['specifications','betterLearningFeatures'].includes(property)) {
          this.setState({[property]: Immutable.asMutable(device[property])});

        } else {
          this.setState({[property]: device[property]});
        }
      });

      if (!device.images) this.setState({images: []});
      if (!device.logo) this.setState({logo: []});
      if (device.slug === 'add-listing') this.setState({name: ''});
    });
  }

  handleCheckboxClick = (property, key, keyProperty='key') => () => {
    const newProperty = this.state[property].map(x => {
      if (x[keyProperty] === key) return {...x, selected: !x.selected};
      return x;
    });
    this.setState({[property]: newProperty});
  }
 
  processDeviceForSubmit = device => {
    const profileFields = [
      "name",
      "story",
      "shortDescription",
      "dataPrivacy",
      "terms",
      "supervision",
      "purchaseModels",
      "ageRange",
      "website",
      "CTAButtonText",
      "demoLink",
      "video",
      "additionalPricingInformation",
      "techRequirements",
      "techSupport",
      "training",
      "trainingSelection",
      "trialSetUp",
      "specialOffer",
      "priceStartingFrom",
      "pricingPage",
      "subjects",
      "requirements",
      "availableToParents",
      "initiator",
      "betterLearningFeatures",
      "localisations",
      "specifications",
      "founded",
      "country",
      "gdpr",
      "supportDetails",
      "availableToParentsDetails",
      "parentPage",
      "brand",
      "os",
      "processor",
      "display",
      "memory",
      "storage",
      "camera",
      "battery",
      "weight",
      "warranty",
    ];
    
    for (const property in device) {
      if (!profileFields.includes(property)) {
        delete device[property];
      
      } else if (property === 'priceStartingFrom' && (!device[property].currency || !device[property].amount || !device[property].period)) {
        delete device.priceStartingFrom;

      } else if (device[property] && wysiwygFields.includes(property)) {
        let html = convertToHTML(device[property].getCurrentContent());
        if (html === '<p></p>') { html = ''};
        device[property] = html;
      
      } else if (['brand'].includes(property)) {
        const selection = device[property].find(x => x.selected);
        device[property] = selection ? selection.slug : null;

      } else if (['ageRange', 'purchaseModels', 'subjects'].includes(property)) {
        device[property] = device[property].filter(x => x.selected).map(x => x.key);

      } else if (['techSupport', 'requirements', 'localisations', 'trainingSelection'].includes(property)) {
        device[property] = device[property].filter(x => x.selected).map(x => x.title);

      } else if (!['numOfReviews'].includes(property) && ['Yes', 'No'].includes(device[property])) {
        device[property] = device[property] === 'Yes';
      }
    }
    return device;
  }

  handleSubmit = () => async () => {
    const device = {...this.state};
    const { logoImages, screenshots } = device;
    
    const logo = (logoImages[0] && logoImages[0].file) ? logoImages[0] : null;
    const images = screenshots[0] &&
      (screenshots.reduce((hasChanges, image) => (hasChanges || !!image.file), false))
      || (device.images && (screenshots.length < device.images.length)) ? screenshots : null;

    const processedDevice = this.processDeviceForSubmit(device);

    if (!processedDevice) {
      toast.error("Error. Fields must not contain links.");
      return;
    }

    if (this.props.device.slug === 'add-listing') {
      this.props.dispatchCreateDevice({
        device: processedDevice,
        screenshots: images,
        logo,
      });
      this.props.tracking.trackEvent({event: 'create-device'});

    } else {
      this.props.dispatchSubmit({
        device: {
          slug: this.props.device.slug,
          ...processedDevice,
        },
        screenshots: images,
        logo,
      });
    }
  };

  renderTechSupport = () =>
    this.state.techSupport.map(({ title, selected }) => {
      const key = slugify(title);
      return (
        <FormGroup check key={key}>
          <Input
            id={key}
            type="checkbox"
            checked={selected}
            onChange={this.handleCheckboxClick('techSupport', title, 'title')}
          />
          <Label check for={key}>
            <LabelText>{title}</LabelText>
          </Label>
        </FormGroup>
    )});

  renderRequirements = () =>
    this.state.requirements.map(({ title, selected }) => {
      const key = slugify(title);
      return (
        <FormGroup check key={key}>
          <Input
            id={key}
            type="checkbox"
            checked={selected}
            onChange={this.handleCheckboxClick('requirements', title, 'title')}
          />
          <Label check for={key}>
            <LabelText>{title}</LabelText>
          </Label>
        </FormGroup>
      );
    });

  renderTrainingSelection = () =>
    this.state.trainingSelection.map(({ title, selected }) => {
      const key = slugify(title);
      return (
        <FormGroup check key={key}>
          <Input
            id={key}
            type="checkbox"
            checked={selected}
            onChange={this.handleCheckboxClick('trainingSelection', title, 'title')}
          />
          <Label check for={key}>
            <LabelText>{title}</LabelText>
          </Label>
        </FormGroup>
      );
    });

  renderLocalisations = () =>
    this.state.localisations.map(({ title, selected }) => {
      const key = slugify(title);
      return (
        <FormGroup check key={key}>
          <Input
            id={key}
            type="checkbox"
            checked={selected}
            onChange={this.handleCheckboxClick('localisations', title, 'title')}
          />
          <Label check for={key}>
            <LabelText>{title}</LabelText>
          </Label>
        </FormGroup>
      );
    });

  renderPurchaseModels = () =>
    this.state.purchaseModels.map(({ key, title, selected }) => (
      <FormGroup check key={key}>
        <Input
          id={key}
          type="checkbox"
          checked={selected}
          onChange={this.handleCheckboxClick('purchaseModels', key)}
        />
        <Label check for={key}>
          <LabelText>{title}</LabelText>
        </Label>
      </FormGroup>
    ));

  renderAges = () =>
    this.state.ageRange.map(({ key, title, selected }) => (
      <FormGroup check key={key}>
        <Input
          id={key}
          type="checkbox"
          checked={selected}
          onChange={this.handleCheckboxClick('ageRange', key)}
        />
        <Label check for={key}>
          <LabelText>{title}</LabelText>
        </Label>
      </FormGroup>
    ));

  renderCheckbox = ({ key, title }) => (
    <FormGroup check key={key}>
      <Input
        id={key}
        type="checkbox"
        checked={this.state[key]}
        onChange={() => this.setState({[key]: !this.state[key]})}
      />
      <Label check for={key}>
        <LabelText>{title}</LabelText>
      </Label>
    </FormGroup>
  );

  renderBrand = () => () => {
    return (
      <Row>
        <Col>
          {this.state.brand.map(({slug, name, selected}) => (
            <FormGroup check key={slug} style={{width: '18rem'}}>
              <Input
                id={slug}
                type="radio"
                checked={selected}
                onChange={this.handleRadioClick('brand', slug, 'slug')}
              />
              <Label check for={slug}>
                <LabelText>{name}</LabelText>
              </Label>
            </FormGroup>
          ))}
        </Col>
      </Row>
    );
  }

  handleRadioClick = (property, key, keyProperty='key') => () => {
    const newProperty = this.state[property].map(x => ({
        ...x,
        selected: x[keyProperty] === key,
    }));
    this.setState({[property]: newProperty});
  }

  handleReviewChange = () => (event) => {
    this.props.dispatchReviewChange(event.target.value);
  }

  handleDetailsChange = () => (event) => {
    this.props.dispatchDetailsChange(event.target.value);
  }

  handleFieldChange = field => value => {
    this.setState({[field]: value});
  }

  render() {
    const { device, createPending, updatePending } = this.props;
    const {
      demoLink,
      story,
      shortDescription,
      website,
      dataPrivacy,
      specialOffer,
      terms,
      CTAButtonText,
      additionalPricingInformation,
      images,
      name,
      priceStartingFrom,
      pricingPage,
      warranty,
      betterLearningFeatures,
      brand,
      freeTrial,
      logo,
    } = this.state;

    const isPremium = this.props.device.plan && this.props.device.plan !== 'free';

    if (!brand || !device) return <Loader />;

    return (
      <StyledDeviceAdmin fluid>
        {(updatePending || createPending) && <LoadingScreen><Loader /></LoadingScreen>}

        <Row className="align-items-center">
          <Col lg={7}>
            <div className="page-title-box">
              <h4 className="font-size-18">Device Details</h4>
              <p>
                This is your public device profile page. 
              </p>
            </div>
          </Col>
        </Row>

              {/* <Question
                title="Brand"
                Input={this.renderBrand()}
              /> */}
         
              <Question
                title="Device Name"
                description="The name of your device as it appears on your website (without any strap lines or keywords)."
                Input={() => <Input required value={name} onChange={(e) => this.setState({name: e.target.value})} type="text" />}
              />

              {logo &&
                <Question
                  title="Featured Image"
                  description="Please use a SQUARE image (130x130px is perfect)."
                  Input={() => (
                    <RUG
                      autoUpload={false}
                      onChange={(images) => {
                        this.setState({ logoImages: images }) // save current component
                      }}
                      rules={{
                        limit: 1,
                        size: 2048,
                      }}
                      initialState={logo.length ? [{source: logo[0], name: ''}] : undefined}
                      header={({ openDialogue }) => (
                        <DropArea>
                          {(isDrag) => (
                            <DropZone onClick={openDialogue}>
                              Drag or click to select file
                            </DropZone>
                          )}
                        </DropArea>
                      )}
                    />
                  )}
                />}

              <Question
                title="Short description"
                description="A one-line elevator pitch that sells your device."
                Input={() => <Input value={shortDescription} onChange={(e) => this.setState({shortDescription: e.target.value})} style={{height: '4rem'}} type="textarea" />}
              />
              
              <Question
                title="Full Description"
                description="Imagine you are speaking to someone that isn’t familiar with your device at all. Be specific and concise. Use paragraphs."
                Input={() => <Editor
                  editorState={story}
                  onEditorStateChange={story => this.setState({story})}
                  toolbar={{
                    options: ['inline', 'history'],
                    inline: {
                      options: ['bold', 'italic', 'underline'],
                    },
                  }}
                />}
              />

              {images &&
                <Question
                  title="Images"
                  description="Choose up to 5 images of the device"
                  Input={() => (
                    <RUG
                      autoUpload={false}
                      onChange={(images) => {
                        this.setState({ screenshots: images }) // save current component
                      }}
                      rules={{
                        limit: 5,
                        size: 2048,
                      }}
                      accept={['jpg', 'jpeg', 'png', 'gif']}
                      initialState={[...images].map(image => ({source: image, name: ''}))}
                      header={({ openDialogue }) => (
                        <DropArea>
                          {(isDrag) => (
                            <DropZone onClick={openDialogue}>
                              Drag or click to select file
                            </DropZone>
                          )}
                        </DropArea>
                      )}
                    />
                  )}
                />
              }

            {/* <Row className="align-items-center">
              <Col sm={6}>
                <div className="page-title-box">
                  <h4 className="font-size-18">Specifications</h4>
                </div>
              </Col>
            </Row>

            <Question
              title="Operating System"
              Input={() => <Input value={this.state.os} onChange={(e) => this.setState({os: e.target.value})} type="text" />}
            />
            <Question
              title="Processor Family"
              Input={() => <Input value={this.state.processor} onChange={(e) => this.setState({processor: e.target.value})} type="text" />}
            />
            <Question
              title="Display Size"
              Input={() => <Input value={this.state.display} onChange={(e) => this.setState({display: e.target.value})} type="text" />}
            />
            <Question
              title="Memory"
              Input={() => <Input value={this.state.memory} onChange={(e) => this.setState({memory: e.target.value})} type="text" />}
            />
            <Question
              title="Internal Storage"
              Input={() => <Input value={this.state.storage} onChange={(e) => this.setState({storage: e.target.value})} type="text" />}
            />
            <Question
              title="Camera"
              Input={() => <Input value={this.state.camera} onChange={(e) => this.setState({camera: e.target.value})} type="text" />}
            />
            <Question
              title="Battery Life"
              Input={() => <Input value={this.state.battery} onChange={(e) => this.setState({battery: e.target.value})} type="text" />}
            />
            <Question
              title="Weight"
              Input={() => <Input value={this.state.weight} onChange={(e) => this.setState({weight: e.target.value})} type="text" />}
            />

            <Row className="align-items-center">
              <Col sm={6}>
                <div className="page-title-box">
                  <h4 className="font-size-18">Features</h4>
                </div>
              </Col>
            </Row>
              
              <Question
                title="Better Learning Features"
                description="Choose the features embedded into your device e.g. colour combinations with good contrast."
                Input={() => <ReactTagInput 
                  placeholder="Type and press enter"
                  tags={betterLearningFeatures} 
                  maxTags={10}
                  editable={false}
                  readOnly={false}
                  removeOnBackspace={true}
                  onChange={(betterLearningFeatures) => this.setState({betterLearningFeatures})}
                />}
              />

              <Question
                title="Localisations Supported"
                description="Select all localisations that your device’s content and instructions support."
                Input={this.renderLocalisations}
              /> */}

            {/* <Row className="align-items-center">
              <Col sm={6}>
                <div className="page-title-box">
                  <h4 className="font-size-18">Policies and Compliance</h4>
                </div>
              </Col>
            </Row>

             <Question
                title="Privacy Policy"
                description="Please link to the web page that displays your privacy policy."
                Input={() => <Input value={dataPrivacy} onChange={(e) => this.setState({dataPrivacy: e.target.value})} type="text" placeholder="https://" />}
              />

              <Question
                title="Terms &amp; Conditions"
                description="Please link to the web page that displays your terms and conditions."
                Input={() => <Input value={terms} onChange={(e) => this.setState({terms: e.target.value})} type="text" placeholder="https://" />}
              />

              <Question
                title="Warranty"
                description=""
                Input={() => <Input value={warranty} onChange={(e) => this.setState({warranty: e.target.value})} style={{height: '4rem'}} type="textarea" />}
              />

            <Row className="align-items-center">
              <Col sm={6}>
                <div className="page-title-box">
                  <h4 className="font-size-18">Pricing</h4>
                </div>
              </Col>
            </Row>

              <Question
                title="Purchase Models"
                description={`What pricing model(s) do you provide?`}
                Input={this.renderPurchaseModels}
              />

              <Question
                title="Price Starting From"
                description="What is the lowest price available?"
                Input={() => (<>
                  <PriceStartingFrom>
                    <SelectSearch
                      options={[{name: '', value: ''}, {name: '£', value: '£'}, {name: '$', value: '$'}, {name: '€', value: '€'}]}
                      onChange={currency => this.setState({priceStartingFrom: {...priceStartingFrom, currency}})}
                      value={priceStartingFrom.currency}
                    />
                    <Input
                      type="number"
                      onChange={(e) => this.setState({priceStartingFrom: {...priceStartingFrom, amount: e.target.value}})}
                      value={priceStartingFrom.amount}
                    />
                    <SelectSearch
                      options={[{name: '', value: ''}, {name: 'per pupil', value: 'per-pupil'}, {name: 'per month', value: 'month'}, {name: 'per year', value: 'year'}, {name: 'one-off fee', value: 'one-off'}]}
                      onChange={period => this.setState({priceStartingFrom: {...priceStartingFrom, period}})}
                      value={priceStartingFrom.period}
                    />
                  </PriceStartingFrom>
                  <p style={{color: '#aaa', margin: '1rem 0 0.25rem'}}>What additional information can you share that prospective customers are usually looking for? Do you have any group pricing? Can you share specific pricing plans?</p>
                  <Editor
                    editorState={additionalPricingInformation}
                    onEditorStateChange={additionalPricingInformation => this.setState({additionalPricingInformation})}
                    toolbar={{options: []}}
                  />
                  </>
                )}
              />

              <Question
                title="Product trial"
                description=""
                Input={() => <Input value={freeTrial} onChange={(e) => this.setState({freeTrial: e.target.value})} style={{height: '4rem'}} type="textarea" />}
              />

            <Row className="align-items-center">
              <Col sm={6}>
                <div className="page-title-box">
                  <h4 className="font-size-18">Lead Generation</h4>
                </div>
              </Col>
            </Row>

              <Question
                title="Lead Capture Page"
                description="Where do you want to send prospective customers?"
                tip="Think carefully about whether this page has been optimised for conversion i.e. does it naturally follow on from your CTA (book demo / free trial)? Is there a form to capture their details?"
                Input={() => <Input value={demoLink} onChange={(e) => this.setState({demoLink: e.target.value})} type="text" placeholder="https://" />}
              />

              <Question
                title="“Visit Website” Button"
                description="Where can prospective customers go to find out more information?"
                tip={`Add a UTM link to the URL so you can track conversions. Here’s a <a href="https://ga-dev-tools.appspot.com/campaign-url-builder/" target="_blank">useful tool</a> to help you add tracking.`}
                Input={() => <Input value={website} onChange={(e) => this.setState({website: e.target.value})} type="text" placeholder="https://" />}
              /> */}

              <Row>
                <Col>
                  <Button onClick={this.handleSubmit()} color="primary">
                    Save and Publish
                  </Button>
                </Col>
              </Row>

      </StyledDeviceAdmin>
    );
  }
}


export const Question = ({title, description, tip, disabled, Input}) => (
  <Row>
    <Col lg={{size: 8, offset: 0}}>
      {disabled && <div style={{marginBottom: '0.25rem'}}>
        <PremiumFeature />
      </div>}
      <Card style={{position: 'relative'}}>
        <CardBody>
          <QuestionTitle>{title}</QuestionTitle>
          {description && <QuestionDescription dangerouslySetInnerHTML={{__html: description}} />}
          {tip && <Alert severity='info'>{tip}</Alert>}
          {Input()}
        </CardBody>
        {disabled && <div style={{position: 'absolute', zIndex: 1, inset: 0, backgroundColor: 'rgba(255,255,255,0.6)'}} />}
      </Card>
    </Col>
  </Row>
);

const PriceStartingFrom = styled.div`
  display: flex;

  .select-search {
    flex: 0 0 130px;

    &:first-child {
      flex: 0 0 80px;
      margin-right: 10px;
    }
  }

  input {
    flex: 0 0 110px;
    margin-right: 10px;
  }
`;

const DropZone = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: #aaa;
  width: 100%;
  min-height: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #eeeeee;
  border-style: dashed;
  background-color: #fafafa;
  padding: 0.5rem;
  cursor: pointer;
`;

const Tabs = styled(Nav)`
  margin-bottom: 1rem;
`;

const Tab = styled(NavItem)`
  cursor: pointer;

  .nav-link.active {
    border-color: #fff;
  }

  &:hover {
    .nav-link {
      border-color: #fff;
    }
  }

  .active {
    border-bottom: 4px solid #FD7252 !important;
    cursor: initial;
    font-weight: bold;
  }
`;

export const QuestionTitle = styled.h5`
  margin-bottom: 0.5rem;
`;

export const QuestionDescription = styled.p`
  margin-bottom: 0.5rem;
  margin-top: -0.25rem;
  color: #aaa;
`;

export const LoadingScreen = styled.div`
  position: absolute;
  inset: 0;
  background-color: rgba(255,255,255,0.6);
  z-index: 999;
`;

const StyledDeviceAdmin = styled(Container)`
  position: relative;
  margin-bottom: 3rem;

  .form-check {
    display: inline-block;
    width: 12rem;
  }

  .rug .rug-items.__card {
    min-height: 0;
    grid-template-columns: repeat(auto-fill, minmax(126px, 1fr));
  }

  .rug-card {
    width: 126px;
    height: 126px;
    background: transparent;
    border: 1px solid #ccc;
  }

  .rug-card .rug-card-name {
    background: transparent;
  }

  .rug-card .rug-card-upload-button {
    display: none;
  }

  .thumb {
    display: inline-flex;
    border-radius: 2px;
    border: 1px solid #eaeaea;
    margin-bottom: 8px;
    margin-right: 8px;
    width: 100px;
    height: 100px;
    padding: 4px;
    box-sizing: border-box;
  };
  
  .thumbInner {
    display: flex;
    minWidth: 0;
    overflow: hidden;
  };
  
  .img {
    display: block;
    width: auto;
    height: 100%;
  };
`;

const OptionContainer = styled.div`
  min-width: 200px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  overflow: hidden;
  display: inline-block;
  line-height: 0.8rem;
  border: solid 1px #0482a2;
`;

const Select = styled.div`
  min-width: 198px;
  box-sizing: border-box;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
`;

const SelectTitle = styled.div`
  min-width: 200px;
  max-width: 200px;
  box-sizing: border-box;
  justify-content: space-between;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  line-height: 0.8rem;
  border: solid 1px #0482a2;
  padding: 0.5rem 1rem;
`;

const OptionBox = styled.div`
  position: absolute;
  z-index: 2;
  border: solid 1px #0482a2;
  margin: -2px 0 0 -1px;
  padding: 0.5rem 0;
  background-color: #fff;
`;

const Option = styled.div`
  min-width: 198px;
  box-sizing: border-box;
  background-color: white;
  cursor: pointer;
  padding: 0.75rem 1rem;
  text-align: left;

  :hover {
    background-color: #0482a2;
    color: white;
  }
`;

const LabelText = styled.span`font-weight: normal;
`;

const mapStateToProps = state => {
  const { updatePending, createPending, device } = state.Device;
  const { brands } = state.Brand;
  return { updatePending, createPending, device, brands };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      dispatchDeviceRequest: actions.deviceRequestAction,
      dispatchSelectDevice: actions.selectDevice,
      dispatchToggleFilter: actions.devicesToggleFilterAction,
      dispatchToggleSubject: actions.devicesToggleSubjectAction,
      dispatchToggleFeature: actions.devicesToggleFeatureAction,
      dispatchToggleType: actions.devicesToggleTypeAction,
      dispatchToggleCheckbox: actions.devicesToggleCheckboxAction,
      dispatchSubmit: actions.updateDeviceAction,
      dispatchPlanSelect: actions.devicesSelectPlanAction,
      dispatchReviewChange: actions.reviewChange,
      dispatchDetailsChange: actions.widgetDetailsChange,
      dispatchResetState: actions.resetState,
      dispatchUploadLogo: actions.uploadLogo,
      dispatchUploadScreenshot: actions.uploadScreenshot,
      dispatchCreateDevice: actions.createDeviceAction,
    },
    dispatch,
  );

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter,
  withTracking(),
)(DeviceAdmin);
